import without from 'lodash/without';

//ToDo: move GroupPage specific utils to the appropriate file.
const timeLabels = {
  'three-days': 'past three days',
  week: 'past week',
  month: 'past month',
  'more-than-a-month': 'more than a month',
};

const badgesLabels = {
  rung2: 'No Full-Price Achievement',
  rung3: 'No Wardrobe Achievement',
  rung4: 'No Upsell Achievement',
  rung5: 'No Relationship Achievement',
  rung6: 'No Big Ticket Achievement',
};

const inCircleLevelsLabels = {
  none: 'Circle none',
  circle1: 'Circle One',
  circle2: 'Circle Two',
  circle3: 'Circle Three',
  circle4: 'Circle Four',
  circle5: 'Circle Five',
  circle6: 'Circle Six',
  presidentsCircle: 'Presidents Circle',
  chairmansCircle: 'Chairman Circle',
};

export const clientAssetsQueryParams = {
  promo: 'PROMO',
  point: 'POINT',
};

const withAssetsLabels = {
  [clientAssetsQueryParams.promo]: 'Promo Card Available',
  [clientAssetsQueryParams.point]: 'Point Card Available',
};

/**
 *
 * @param {Object} filters
 * @param {String} filterName
 * @param {Object} labelNames
 *
 * @return {*[]}
 */
export const getLabelsForCommaSeparatedFilterString = (filters, filterName, labelNames = null) => {
  const filterString = filters[filterName];
  return filterString.split(',').map((value) => ({
    label: labelNames ? labelNames[value] : value,
    filter: filterName,
    clear(currentFilters, setFilters) {
      const clearedFilters = without(currentFilters[filterName].split(','), value).join(',');

      setFilters({
        ...currentFilters,
        [filterName]: clearedFilters,
      });
    },
  }));
};

export function getFilterLabels(filters) {
  const labels = [];

  if (filters.isNmAppUser) {
    labels.push({
      label: 'NM App User',
      clear(filters, setFilters) {
        setFilters({ ...filters, isNmAppUser: false });
      },
    });
  }

  if (filters.connectedWithMe) {
    labels.push({
      label: 'Client connects available',
      clear(filters, setFilters) {
        setFilters({ ...filters, connectedWithMe: false });
      },
    });
  }

  if (filters.contactedFrom) {
    labels.push({
      label: `Contacted ${timeLabels[filters.contactedFrom]}`,
      clear(filters, setFilters) {
        setFilters({ ...filters, contactedFrom: '' });
      },
    });
  }

  if (filters.contactedTill) {
    labels.push({
      label: `Contacted ${timeLabels[filters.contactedTill]}`,
      clear(filters, setFilters) {
        setFilters({ ...filters, contactedTill: '' });
      },
    });
  }

  if (filters.shoppedWithMe) {
    labels.push({
      label: 'Shopped with me',
      clear(filters, setFilters) {
        setFilters({ ...filters, shoppedWithMe: false });
      },
    });
  }

  if (filters.shoppedFrom) {
    labels.push({
      label: `Shopped in last ${filters.shoppedFrom}`,
      clear(filters, setFilters) {
        setFilters({ ...filters, shoppedFrom: '' });
      },
    });
  }

  if (filters.inCircleLevel) {
    const levels = getLabelsForCommaSeparatedFilterString(filters, 'inCircleLevel', inCircleLevelsLabels);
    labels.push(...levels);
  }

  if (filters.withAssets) {
    const withAssets = getLabelsForCommaSeparatedFilterString(filters, 'withAssets', withAssetsLabels);
    labels.push(...withAssets);
  }

  if (filters.withNoBadges) {
    const badges = getLabelsForCommaSeparatedFilterString(filters, 'withNoBadges', badgesLabels);
    labels.push(...badges);
  }

  if (filters.conciergeItems) {
    labels.push({
      label: 'Items in concierge Bag',
      clear(filters, setFilters) {
        setFilters({ ...filters, conciergeItems: false });
      },
    });
  }

  if (filters.departments) {
    const departments = getLabelsForCommaSeparatedFilterString(filters, 'departments');
    labels.push(...departments);
  }

  if (filters.designers) {
    const designers = getLabelsForCommaSeparatedFilterString(filters, 'designers');
    labels.push(...designers);
  }

  if (filters.divisions) {
    const divisions = getLabelsForCommaSeparatedFilterString(filters, 'divisions');
    labels.push(...divisions);
  }

  if (filters.marketingEvents) {
    const events = getLabelsForCommaSeparatedFilterString(filters, 'marketingEvents');
    labels.push(...events);
  }

  return labels;
}
